import { com } from '@eidu/web'
import syncApiBaseUrl from './syncApiBaseUrl'
import requireAuthContext from '../authorization/requireAuthContext'
import createBrowserDomainEventWriteService = com.eidu.sharedlib.event.createBrowserDomainEventWriteService
import AuthenticationContext = com.eidu.sharedlib.event.context.AuthenticationContext

const domainEventWriteService = createBrowserDomainEventWriteService(
  syncApiBaseUrl,
  async () => {
    const authContext = await requireAuthContext()
    return new AuthenticationContext(authContext.accessToken, authContext.organizationId, authContext.userEntityId)
  },
  Number(import.meta.env.VITE_APP_VERSION_INT ?? 0)
)

export default domainEventWriteService
